import React from 'react'
import Modal from '../Modal'
import { promiseAPI } from '@/utils/modal'
import { closeEndCoopEventEmitter } from '@/modules/distribute/constants/closeEndCoopEventEmitter'
import { ModalContentType } from '../noticeType'
import styles from './index.less'

const helperUrlMap = {
    dev: 'https://testhelp.scm121.com/puAnnouncement',
    test: 'https://testhelp.scm121.com/puAnnouncement',
    uat: 'https://uathelp.scm121.com/puAnnouncement',
    pre: 'https://prehelp.scm121.com/puAnnouncement',
    prod: 'https://help.scm121.com/puAnnouncement',
}

const mode = PROJECT_CONFIG.sentryMode || PROJECT_CONFIG.mode || 'dev'

export const openNotice = promiseAPI(Modal)

export const openErpNotice = (props: ModalContentType) => {
    let dialog: { hide: () => void; show: () => void } | null = null

    const uToken = window.jmx.createToken()

    const handleOk = () => {
        window.jmx.off('gyl.pu_announcement.ok', handleOk, { token: uToken })

        if (dialog) {
            dialog.hide()
        }
    }

    window.jmx.on('gyl.pu_announcement.ok', handleOk, { token: uToken })

    dialog = new window.Dialog({
        name: '分销资金及售后服务保障产品升级公告',
        url: helperUrlMap[mode],
        urlQuery: {
            jmxToken: uToken,
            ...props,
        },
        mode: 'jmx',
        opener: window.top,
        width: 720,
        height: 630,
        titleVisible: false,
        close_type: 'hide',
        auto_position: true,
    })

    dialog?.show()
}

const InlineNotice = (props: ModalContentType & NoticeDivType) => {
    const { code, isSmall } = props

    return (
        <div className={styles.inlineNotice} {...props}>
            <img
                className={styles.icon}
                src="https://assets.sursung.com/activity/20241209/0B7BD5B1BADB453F91B107D629928A4E1733753994286.png"
                alt=""
                width={14}
                height={14}
            />
            <div className={styles.message}>{isSmall ? '升级公告' : '分销资金及售后服务保障产品升级公告'}</div>
            <a
                className={styles.action}
                onClick={() => {
                    openNotice({ code })
                    closeEndCoopEventEmitter.next()
                }}
            >
                查看
            </a>
        </div>
    )
}

const FullNotice = (props: ModalContentType & NoticeDivType) => {
    const { code } = props

    return (
        <div className={styles.fullNotice} {...props}>
            <img
                className={styles.icon}
                src="https://assets.sursung.com/activity/20241209/EEF1A37EBB07423098B37874D384CAE01733754111812.png"
                alt=""
                width={20}
                height={20}
            />
            <div className={styles.message}>分销资金及售后服务保障产品升级公告</div>
            <div className={styles.divider} />
            <a
                className={styles.action}
                onClick={() => {
                    openNotice({ code })
                    closeEndCoopEventEmitter.next()
                }}
            >
                查看
            </a>
        </div>
    )
}

type NoticeDivType = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
export default ({
    full,
    ...restProps
}: NoticeDivType & {
    full?: boolean
} & ModalContentType) => {
    if (full) {
        return <FullNotice {...restProps} />
    }
    return <InlineNotice {...restProps} />
}
